import { render } from "./Curation.vue?vue&type=template&id=d982e06e&scoped=true&ts=true"
import script from "./Curation.vue?vue&type=script&lang=ts"
export * from "./Curation.vue?vue&type=script&lang=ts"

import "./Curation.vue?vue&type=style&index=0&id=d982e06e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d982e06e"]])

export default __exports__